/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from '../../styles/styled';
import { hexToRgb } from '../../styles/utils';
import NykaaLogo from './Icons/NykaaLogoColored';
import { SIZE, SPINNER_INDETERMINATE_TIME, } from '../constants';
import { getSpinnerSizeStyle, getSpinnerLogoSize, getFontStyle, getDasharray, getDashoffset, getSpinnerDimensions, getSpinnerBackground, } from './helpers';
const Wrapper = styled.div `
  width: max-content;
  ${(props) => {
    const { withBackground, theme, size } = props;
    const backGroundStyles = getSpinnerBackground({ theme, withBackground, size });
    return Object.assign({}, backGroundStyles);
}} 
`;
const Container = styled.div `
  position: relative;
  ${(props) => {
    const { size } = props;
    const dimensions = getSpinnerSizeStyle({ size });
    return Object.assign({}, dimensions);
}}
`;
const SpinnerSvg = styled.svg `
  display: flex;
  position: absolute;
  ${(props) => {
    const { size } = props;
    const dimensions = getSpinnerSizeStyle({ size });
    return Object.assign({}, dimensions);
}}

  animation-name: ${({ isDeterminate }) => !isDeterminate && 'spin'};
  animation-timing-function: linear;
  animation-duration: ${({ indeterminateTime }) => (`${indeterminateTime || SPINNER_INDETERMINATE_TIME}s`)};
  animation-iteration-count: infinite;
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
const SpinnerBorder = styled.circle `
  cx: 50%;
  cy: 50%;
  fill: none;
  stroke: ${({ theme }) => `${hexToRgb(theme.colors.primary, 0.08)}`};

  ${(props) => {
    const { size, strokeWidth, r } = props;
    const strokeDasharray = getDasharray({ size });
    return {
        strokeWidth,
        r,
        strokeDasharray,
    };
}}
`;
const SpinnerProgress = styled.circle `
  cx: 50%;
  cy: 50%;
  fill: none;
  stroke: ${({ theme }) => theme.colors.primary};
  stroke-linecap: round;
  transform: rotate(-90deg) translate(-100%, 0);
  transition: stroke-dashoffset 0.5s linear;

  ${(props) => {
    const { size, value, strokeWidth, r, } = props;
    const strokeDasharray = getDasharray({ size });
    const strokeDashoffset = getDashoffset({ value, size });
    return {
        strokeWidth,
        r,
        strokeDasharray,
        strokeDashoffset,
    };
}}
`;
const SpinnerIndeterminate = styled.circle `
  cx: 50%;
  cy: 50%;
  r: 20;
  fill: none;
  border: 5px solid ${({ theme }) => theme.colors.surface};
  border-radius: 50%;
  stroke: ${({ theme }) => theme.colors.primary};
  stroke-linecap: round;
  animation: stretch ${({ indeterminateTime }) => (`${(indeterminateTime || SPINNER_INDETERMINATE_TIME) * 0.75}s`)} ease-in-out infinite;

  ${(props) => {
    const { size, strokeWidth, r } = props;
    const strokeDasharray = getDasharray({ size });
    return `
      r: ${r};
      stroke-width: ${strokeWidth};
      stroke-dasharray: ${strokeDasharray};

      @keyframes stretch {
        0% {
          stroke-dasharray: 0, 300;
          stroke-dashoffset: 0;
        }
        50% {
          stroke-dasharray: ${strokeDasharray - 30}, 300;
          stroke-dashoffset: -35px;
        }
        100% {
          stroke-dashoffset: -${strokeDasharray};
        }
      };
    `;
}};
`;
const SpinnerCenter = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: ${({ theme }) => theme.colors.primary};

  ${(props) => {
    const { size, theme } = props;
    const fontSize = getFontStyle({ size, theme });
    return Object.assign({}, fontSize);
}}
`;
const Logo = styled.div `
  display: flex;
  svg {
    ${({ size }) => {
    const dimensions = getSpinnerLogoSize({ size });
    return Object.assign({}, dimensions);
}}
  };
`;
const Spinner = (props) => {
    const { isDeterminate, showLogo, size, value, showValue, indeterminateTime, } = props;
    const { strokeWidth, r } = getSpinnerDimensions({ size });
    const DeterminateSpinner = (React.createElement(SpinnerProgress, { value: value, size: size, strokeWidth: strokeWidth, r: r }));
    const IndeterminateSpinner = (React.createElement(React.Fragment, null,
        React.createElement(SpinnerIndeterminate, { value: value, size: size, indeterminateTime: indeterminateTime, strokeWidth: strokeWidth, r: r })));
    const LogoT = (React.createElement(Logo, { size: size },
        React.createElement(NykaaLogo, null)));
    const valuePer = `${value}%`;
    return (React.createElement(Wrapper, Object.assign({}, props),
        React.createElement(Container, Object.assign({}, props),
            React.createElement(SpinnerSvg, { isDeterminate: isDeterminate, size: size, indeterminateTime: indeterminateTime },
                isDeterminate && React.createElement(SpinnerBorder, { size: size, strokeWidth: strokeWidth, r: r }),
                isDeterminate ? DeterminateSpinner : IndeterminateSpinner),
            showLogo && React.createElement(SpinnerCenter, null, LogoT),
            showValue && !showLogo && (size !== SIZE.small) && isDeterminate && (React.createElement(SpinnerCenter, Object.assign({}, props), valuePer)))));
};
export default Spinner;
